var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 12,
    viewBox: "0 0 35 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.771484,
    width: 34.7485,
    height: 11.0552,
    rx: 4,
    fill: "#EBECFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1258_91516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09689 9.07514C4.31973 9.29968 5.01731 9.82685 6.27684 9.82685C7.70108 9.82685 8.56337 8.81156 8.56337 7.80602C8.56337 6.47832 7.36198 5.88281 6.60626 5.58017C5.84085 5.26777 5.55019 4.99442 5.55019 4.6332C5.55019 4.36962 5.81179 4.13531 6.16058 4.13531C6.75159 4.13531 7.45887 4.67225 7.54606 4.72107C7.63326 4.78941 7.80766 4.70154 7.87548 4.59416L8.3696 3.84244C8.40836 3.7741 8.42773 3.59838 8.31147 3.53004C8.02081 3.31527 7.24571 2.79785 6.23809 2.79785C4.74603 2.79785 4 3.7741 4 4.74059C4 5.91209 5.04638 6.56618 5.87961 6.89811C6.53844 7.1617 6.87754 7.47409 6.87754 7.88412C6.87754 8.22581 6.59657 8.46987 6.20902 8.46987C5.56957 8.46987 4.87198 7.95246 4.83323 7.93293C4.7654 7.88412 4.58132 7.8646 4.50381 7.99151L4.04844 8.8018C3.97093 8.93845 4 8.97753 4.09689 9.07514Z",
    fill: "#012240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74414 9.54376C9.74414 9.64143 9.83134 9.72928 9.92823 9.72928H11.0909C11.1877 9.72928 11.275 9.64143 11.275 9.54376V3.081C11.275 2.98337 11.1877 2.89551 11.0909 2.89551H9.92823C9.83134 2.89551 9.74414 2.98337 9.74414 3.081V9.54376Z",
    fill: "#012240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6191 9.54376C18.6191 9.64143 18.6966 9.72928 18.8032 9.72928H19.9562C20.0531 9.72928 20.1402 9.64143 20.1402 9.54376V7.05434H20.8088L22.0974 9.64143C22.1167 9.68044 22.1749 9.72928 22.2524 9.72928H23.541C23.7057 9.72928 23.7735 9.57308 23.7057 9.44615L22.3783 6.96648C23.2213 6.62479 23.8123 5.90237 23.8123 5.00421C23.8123 3.84247 22.8628 2.89551 21.7001 2.89551H18.8032C18.6966 2.89551 18.6191 2.98337 18.6191 3.081V9.54376ZM20.1402 5.8145V4.29155H21.5742C21.9714 4.29155 22.3106 4.62348 22.3106 5.0335C22.3106 5.44352 21.9714 5.8145 21.5742 5.8145H20.1402Z",
    fill: "#012240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4024 9.72925H25.4682C25.6619 9.72925 25.7685 9.61207 25.8169 9.49495L26.1658 8.71393H28.801L29.1499 9.4852C29.237 9.67066 29.3145 9.72925 29.4889 9.72925H30.5644C30.7097 9.72925 30.7872 9.60231 30.7291 9.47538L27.6966 2.90524C27.6675 2.84666 27.5997 2.79785 27.5318 2.79785H27.435C27.3671 2.79785 27.2993 2.84666 27.2702 2.90524L24.2377 9.47538C24.1796 9.60231 24.257 9.72925 24.4024 9.72925ZM26.747 7.38624L27.4737 5.77542H27.4834L28.2197 7.38624H26.747Z",
    fill: "#012240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 4.32734H17.361V2.89551H12.9688V4.32734Z",
    fill: "url(#paint0_linear_1258_91516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 6.99531H16.8442V5.56348H12.9688V6.99531Z",
    fill: "url(#paint1_linear_1258_91516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 9.72873H17.2964V8.29688H12.9688V9.72873Z",
    fill: "url(#paint2_linear_1258_91516)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1258_91516",
    x1: 17.361,
    y1: 3.61143,
    x2: 12.9688,
    y2: 3.61143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116FD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1258_91516",
    x1: 16.8442,
    y1: 6.2794,
    x2: 12.9688,
    y2: 6.2794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116FD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1258_91516",
    x1: 17.2964,
    y1: 9.01278,
    x2: 12.9688,
    y2: 9.01278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99C5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116FD6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1258_91516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7485,
    height: 7.05521,
    fill: "white",
    transform: "translate(4 2.77148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiera);
export default __webpack_public_path__ + "static/media/siera.cd8bdfe28f6f7b4fb269ec775e50ff7f.svg";
export { ForwardRef as ReactComponent };